import { _$id, _addEventListener, } from '../util/dom';
import { _addKeyHandlers, } from './key-handlers';
const _addActionToHistory = (redoWith, undoWith, actionData) => {
    const action = {
        u: undoWith,
        r: redoWith,
        d: actionData,
    }, newPosition = {
        p: _currentPosition,
        u: action,
        r: null,
        n: null,
    };
    _currentPosition.r = action;
    _currentPosition.n = newPosition;
    _currentPosition = newPosition;
    _updateButtonState();
}, undo = () => {
    const undoAction = _currentPosition.u, previousPosition = _currentPosition.p;
    if (!undoAction || !previousPosition) {
        return;
    }
    const undoWith = undoAction.u, actionData = undoAction.d;
    undoWith(actionData);
    _currentPosition = previousPosition;
    _updateButtonState();
}, redo = () => {
    const redoAction = _currentPosition.r, nextPosition = _currentPosition.n;
    if (!redoAction || !nextPosition) {
        return;
    }
    const redoWith = redoAction.r, actionData = redoAction.d;
    redoWith(actionData);
    _currentPosition = nextPosition;
    _updateButtonState();
}, _updateButtonState = () => {
    _$undoButton.disabled = !_currentPosition.u;
    _$redoButton.disabled = !_currentPosition.r;
}, _$undoButton = _$id('undo-button'), _$redoButton = _$id('redo-button');
let _currentPosition = {
    r: null,
    n: null,
};
_addEventListener(_$undoButton, 'click', undo);
_addEventListener(_$redoButton, 'click', redo);
_addKeyHandlers('u', undo);
_addKeyHandlers('i', redo);
export { _addActionToHistory, };
